<script setup>
import LogoImg from '@/assets/img/logo.png'
import { ref } from 'vue'
import { useRouter } from 'vue-router'
// 只保留必要的导入
import { RouterView } from 'vue-router'
import { provide, onMounted, computed } from 'vue'
import BgImg from './assets/img/bg.png'

// 定义 API 基础 URL - 使用完整的绝对路径
const apiBaseUrl = 'https://fcsgroup9.com'

// 提供给所有子组件
provide('apiBaseUrl', apiBaseUrl)
const isMenuOpen = ref(false)
const router = useRouter()

// 检测是否处于 iframe 中
const isInIframe = ref(false)
const appStyle = computed(() => (isInIframe.value ? {} : { backgroundImage: `url(${BgImg})` }))

onMounted(() => {
    try {
        isInIframe.value = window.self !== window.top
    } catch (e) {
        // 跨域访问 window.top 可能抛错，视为在 iframe 中
        isInIframe.value = true
    }
})

// 添加切换菜单方法
const toggleMenu = () => {

    isMenuOpen.value = !isMenuOpen.value
}

// 添加导航方法
const navigateTo = (path) => {
    router.push(path)
    isMenuOpen.value = false // 导航后关闭菜单
}
</script>

<template>

    <div class="app-container" :style="appStyle">
        <div class="menu-container">
            <div class="menu-item" @click="toggleMenu">
                <span class="mdi mdi-menu"></span>

            </div>

            <!-- 导航菜单 -->
            <div class="nav-menu" :class="{ 'nav-menu-open': isMenuOpen }">
                <img :src="LogoImg" alt="Fair Dinkum Pokies" style="width: 100%;">
                <div class="nav-item" @click="navigateTo('/')">
                    <span class="nav-icon">🏠</span>
                    <span class="nav-text">Home</span>
                </div>
                <div class="nav-item" @click="navigateTo('/blog')">
                    <span class="nav-icon">📝</span>
                    <span class="nav-text">Blog</span>
                </div>
            </div>

            <!-- 遮罩层 -->
            <div class="menu-overlay" v-if="isMenuOpen" @click="toggleMenu"></div>
        </div>
        <RouterView />
    </div>
</template>
<style>
.menu-container {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1000;
}

.menu-item {
    padding: 10px;
    font-size: 24px;
    cursor: pointer;
}

.main-logo {
    width: 50px;
    height: 50px;
    transition: transform 0.3s ease;
}

.menu-item:hover .main-logo {
    transform: scale(1.1);
}

.nav-menu {
    position: fixed;
    top: 0;
    left: -250px;
    width: 250px;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.9);
    transition: left 0.3s ease;
    padding-top: 30px;

    z-index: 999;
}

.nav-menu-open {
    left: 0;
}

.nav-item {
    display: flex;
    align-items: center;
    padding: 15px 20px;
    color: #fff;
    cursor: pointer;
    transition: background-color 0.3s ease;
}

.nav-item:hover {
    background-color: rgba(255, 215, 0, 0.2);
}

.nav-icon {
    font-size: 24px;
    margin-right: 15px;
}

.nav-text {
    font-size: 18px;
    font-weight: 500;
}

.menu-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 998;
}

/* 响应式调整 */
@media (max-width: 768px) {
    .nav-menu {
        width: 200px;
    }

    .nav-text {
        font-size: 16px;
    }
}
</style>
